export default function isMeterScoringPromptConfigured(content, meterId) {
    return (content.meterScoringPrompts?.[meterId]?.prompt ?? '').trim() !== '';
}
